import Counter from 'counter.js';
import inView from 'in-view';

$(document).ready(() => {

    inView('.inview')
        .on('enter', imageEnter);

    function imageEnter(el) {
        if(!el.done) {
            $(el).addClass('fadeInUp');
            el.done = true;
        }
    }

    inView('.inview-autoplay')
        .on('enter', autoplay)
        .on('exit', clear);

    var scroller;

    function autoplay(el) {
        var buttons = $(el).find('.workflow-pagination li');
        $(buttons.get(0)).trigger('click', ['true']);
        var pointer = 1;
        scroller = setInterval(function() {

            $(buttons.get(pointer)).trigger('click', ['true']);

            pointer = (pointer + 1 < buttons.length) ? pointer + 1 : 0;
            
        }, 11000);
        $(el).click(clear);
    }

    function clear() {
        clearInterval(scroller);
    }

    inView.offset(100);
    inView('.counter').on('enter', statEnter);

    function statEnter(el) {
        if(!el.done) {
            // set your desired options
            const opts = {
                start: 0,
                end: el.innerHTML,
                duration: 5000,
                selector: el,
                done: () => {}
            };

            // create an instance
            const instance = new Counter(opts);

            // run the counter
            instance.run();
            el.done = true;
        }
    }

    var regex = /(\d+|[^\d]+)/g
    inView('.inview-boxcount').on('enter', (el) => {
        if(!el.done) {
            var rand = Math.random();
            var inner = "";
            var chunks = $(el).text().match(regex);

            $(chunks).each((i,e) => {
                var node = "<big class='" + ($.isNumeric(e) ? 'numeric' : '') + "'>" + e + "</big>";
                inner += node;
            });

            $(el).html(inner);

            $(el).children('.numeric').each((i,e) => {
                statEnter(e); 
            });

            el.done = true;
        }
    });

});



// WEBPACK FOOTER //
// ./src/js/inview.js